import { ProblemType } from "../model/enumerations/problem-type-model";
import { ISelect } from "../model/iSelect";

export const problemTypeEnum = (): Array<ISelect> => {
  const problemType: Array<ISelect> = [
    {
      label: "Datos Incorrectos",
      value: ProblemType.WRONG_DATA,
    },
    {
      label: "Reclamo",
      value: ProblemType.CLAIM,
    },
    {
      label: "Petición",
      value: ProblemType.REQUEST,
    },
    {
      label: "Otros",
      value: ProblemType.OTHER,
    },
  ];
  return problemType;
};
